// extracted by mini-css-extract-plugin
export default {"icon":"SocialIcon_icon__9OMCZ"};